import { render, staticRenderFns } from "./tendenze.html?vue&type=template&id=65ce57b4&scoped=true&"
import script from "./Tendenze.vue?vue&type=script&lang=js&"
export * from "./Tendenze.vue?vue&type=script&lang=js&"
import style0 from "./Tendenze.vue?vue&type=style&index=0&id=65ce57b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ce57b4",
  null
  
)

export default component.exports